<div [class]="classes">
  <div class="bk-card__header"><ng-content select="[bk-card-header]"></ng-content></div>
  <div class="bk-card__body"><ng-content></ng-content></div>
  <div class="bk-card__footer"><ng-content select="[bk-card-footer]"></ng-content></div>
</div>
